export const isString = (entity: unknown): entity is string => typeof entity === 'string'
